import "../css/footer.css";
import { useState } from "react";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import consts from "../consts.js";

function Footer({ language }) {
  const message =
    language === consts.ENGLISH
      ? consts.FooterText_English
      : consts.FooterText_Espanol;

  return (
    <div className="Footer">
      <div className="message">{message}</div>
      <div className="address">
        <a
          href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
            consts.Address
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Open address in Google Maps: ${consts.Address}`}
        >
          {consts.Address}
        </a>
      </div>
      <div className="social-media">
        <a
          href="https://www.facebook.com/story.php?story_fbid=122126877272987495&id=61579624866013&_rdr"
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginRight: "12px" }}
        >
          <FaFacebook size={32} color="#1877F3" />
        </a>
        <a
          href="https://www.instagram.com/foreman_event_center/?igsh=bWF5a2g4MWp6OWQ5&utm_source=qr#"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram size={32} color="#E4405F" />
        </a>
      </div>
    </div>
  );
}

export default Footer;
